<template>
    <div>
        <label for="estimated_hours"
               class="control-label">{{trans('tasks.fields.estimated_hours')}}
            *</label>
        <el-slider
                v-model="value"
                :step="0.5"
                show-input>
        </el-slider>
        <input type="hidden" :value="value" name="estimated_hours" id="estimated_hours">
        <div class="text-right"><small>Use dot (e.g. 4.5) for 0.5 hour</small></div>
    </div>
</template>

<script>
    export default {
        name: "eh-slider",
        props: {
            initValue: Number,
        },
        data() {
            return {
                value: this.initValue,
            }
        },
        methods:
            {
                trans(path) {
                    return Lang.trans(path);
                }
            }
    }
</script>

<style lang="scss">
    .el-slider__bar {
        background-color: #f49996 !important;
    }
    .el-slider__button {
        border: 2px solid #f49996 !important;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/tasks/EhSlider.vue